import {
  STATUS_READ,
  STATUS_ARCHIVE
} from '@/const/whistleblower';

export default (whistleblower) => {
  function isUserCanArchive() {
    if (!whistleblower) return false;
    const canArchiveStatus = [STATUS_READ];
    const canArchive = canArchiveStatus.includes(whistleblower.status);
    return canArchive;
  }

  function isUserCanUnarchive() {
    if (!whistleblower) return false;
    const canUnArchiveStatus = [STATUS_ARCHIVE];
    const canUnArchive = canUnArchiveStatus.includes(whistleblower.status);
    return canUnArchive;
  }

  return {
    ...whistleblower,
    isUserCanArchive,
    isUserCanUnarchive
  };
};
